<template>
  <m-contents-wrapper :content-type="contentType" :content-category="contentCategory">
    <template slot-scope="{ contents,pagination,changePageFunction }">

      <swiper id="slider302" class="w-100" ref="mySwiper" :options="swiperOptions">

        <swiper-slide v-for="content in contents" :key="content.id" class=" w-100">
          <div class="content-of-main-section">
            <img :src="content.thumbnail" class="img-slider " :alt="content.title">
          </div>
          <div class="position-absolute box-on-image">
            <m-a :href="{name:'SinglePage',params:{slug:content.slug}}" class="text-center">
              <p class="text-right text-white slider-p">
                {{ content.title }}
              </p>
            </m-a>
            <b-col lg="12" class="text-right p-0 slider-ab">
              <m-a :href="{name:'SinglePage',params:{slug:content.slug}}" class="text-center">
                <b-button class="button-slider rounded-0">
                  <span>مطالعه بیشتر</span>
                  <b-icon icon="arrow-left" class="mr-1"/>
                </b-button>
              </m-a>
            </b-col>
          </div>
        </swiper-slide>

        <div class="swiper-pagination" slot="pagination"></div>
        <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>
      </swiper>


    </template>
  </m-contents-wrapper>
</template>

<script>
import {directive, Swiper, SwiperSlide} from "vue-awesome-swiper";

export default {
  name: "S302",
  props: {
    contentType: {
      default: 'post'
    },
    contentCategory: {
      default: () => {
        return ['header-slider']
      }
    },
  },
  components: {Swiper, SwiperSlide, directive},
  data() {
    return {
      swiperOptions: {
        autoplay: {
          delay: 2000,
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
          dynamicBullets: true
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
    };
  },
};
</script>

<style>
#slider302:hover > .swiper-wrapper .swiper-slide div a button {
  background-color: var(--primary) !important;
  color: var(--light) !important;
  transition-duration: 0.4s;
  height: 50px;
  border: none !important;
}

/* slider buttons */
#slider302 .swiper-button-next, #slider302 .swiper-button-prev {
  color: var(--secondary) !important;
}

#slider302 .swiper-pagination-bullet, #slider302 .swiper-pagination-bullet-active, #slider302 .swiper-pagination-bullet-active-main {
  color: var(--primary) !important;
  background: var(--primary) !important;
}

/* slider buttons */
</style>

<style scoped>


#slider302 {
  min-height: auto;
  max-height: 650px;
}

.box-on-image {
  bottom: 8px;
  right: 16px;
}

.button-slider {
  text-align: right !important;
  width: 150px;
  background-color: var(--secondary) !important;
  color: var(--primary) !important;
  transition-duration: 0.4s;
  height: 1px;
  overflow: hidden;
  border: none !important;
}


.content-of-main-section:before {
  content: "";
  display: block;
  position: absolute;
  top: 75%;
  right: 0;
  bottom: 0;
  left: 0;
  opacity: 0.8;
  background-image: linear-gradient(180deg, rgba(42, 60, 110, 0) 0%, var(--light-info) 100%);
}

.img-slider {
  width: 100%;
  object-fit: cover;
  max-height: 650px;
  min-height: auto;
  cursor: pointer;
}


</style>
